import axios from 'axios'
const dotenv = require('dotenv')
dotenv.config()
let configFile = 'pfConfig'
// let configFile = 'pfConfig'
var configData = require(`../../../config/${configFile}.json`)  
// alert(configFile)
export default () => {
    if (process.env.NODE_ENV === 'development') {
        return axios.create({
            // baseURL: configData.productionApi,

            baseURL: 'http://' + configData.devDatabaseIp + ':' + configData.developmentServerPort,
            headers: {
                apikey: configData.apikey
            }
        })
    }
    if (process.env.NODE_ENV === 'staging') {
        return axios.create({
            baseURL: configData.stagingApi,
            headers: {
                apikey: configData.apikey
            }
        })
    }
    if (process.env.NODE_ENV === 'production') {
        return axios.create({
            baseURL: configData.productionApi,
            headers: {
                apikey: configData.apikey
            }
        })
    }
}